import classNames from 'classnames';

import { PromoteDataWithVariableSymbol } from './ReprePromote';
import { ReprePromoteType } from './ReprePromoteForm';

const BANK_ACCOUNT = '2303028341';
const BANK_CODE = '2010';

type Props = {
  data: PromoteDataWithVariableSymbol;
  className?: string;
};

function ReprePromotePayment({ data, className }: Props) {
  const price = data.type === ReprePromoteType.BASIC ? 1499 : 3499;
  const qrUrl = usePaymentQR(data.variableSymbol, price);

  return (
    <div className={classNames('ReprePromote__payment', className)}>
      <h1>Děkujeme za podporu!</h1>
      <p>
        Potvrzení objednávky bylo odesláno na Váš e-mail. Platbu prosím proveďte podle následujících
        údajů:
      </p>
      <div className='ReprePromote__paymentInfo'>
        <div className='ReprePromote__paymentInfoColumn'>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img src={qrUrl} alt='QR platba' />
        </div>
        <div className='ReprePromote__paymentInfoColumn'>
          <div className='ReprePromote__paymentInfoRow'>
            <span>Číslo účtu:</span>
            <strong>
              {BANK_ACCOUNT}/{BANK_CODE}
            </strong>
          </div>
          <div className='ReprePromote__paymentInfoRow'>
            <span>Variabilní symbol:</span>
            <strong>{data.variableSymbol}</strong>
          </div>
          <div className='ReprePromote__paymentInfoRow'>
            <span>Částka:</span>
            <strong>
              {new Intl.NumberFormat('cs-CZ', {
                style: 'currency',
                currency: 'CZK',
                minimumFractionDigits: 0,
              }).format(price)}
            </strong>
          </div>
        </div>
      </div>
      <p>
        Platební údaje jsme Vám také zaslali na e-mail. Pokud e-mail nevidíte, zkontrolujte složku
        spam. Jakmile platbu obdržíme, budeme Vás informovat o dalším postupu. Děkujeme za Vaši
        objednávku!
      </p>
    </div>
  );
}

export default ReprePromotePayment;

function usePaymentQR(variableSymbol: string, price: number) {
  const params = new URLSearchParams({
    accountNumber: BANK_ACCOUNT,
    bankCode: BANK_CODE,
    vs: variableSymbol,
    currency: 'CZK',
    branding: String(false),
    size: '250',
    amount: String(price),
  });

  return `https://api.paylibo.com/paylibo/generator/czech/image?${params}`;
}
